var EmptyBox = "https://shopfront-cdn.tekoapis.com/static/bd56488f2247217f.png";

export { EmptyBox as default };
